export function hasPaidAccess(value) {
  return value === 1 || value === true || value === "1";
}
